// src/App.jsx
import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
// App.jsx (top)
import ToastMessage, { showToast } from "./components/ToastMessage.jsx";

import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import PrivateRoute from "./components/PrivateRoute.jsx";

// Auth screens
import LoginScreen from "./screens/auth/LoginScreen.jsx";
import RegisterScreen from "./screens/auth/RegisterScreen.jsx";
import ForgotPasswordScreen from "./screens/auth/ForgotPasswordScreen.jsx";
import ResetPasswordScreen from "./screens/auth/ResetPasswordScreen.jsx";

// Public page
import HomeScreen from "./screens/HomeScreen.jsx";

// Patient screens
import AppointmentScreen from "./screens/patient/AppointmentScreen.jsx";
import MyAppointmentsScreen from "./screens/patient/MyAppointmentsScreen.jsx";
import LabReportsScreen from "./screens/patient/LabReportsScreen.jsx";
import MedicineScreen from "./screens/patient/MedicineScreen.jsx";
import HistoryScreen from "./screens/patient/HistoryScreen.jsx";

// Doctor screens
import DoctorDashboard from "./screens/doctor/DoctorDashboard.jsx";

// Admin screens
import AdminDashboard from "./screens/admin/AdminDashboard.jsx";
import ManageDoctors from "./screens/admin/ManageDoctors.jsx";
import ManageMedicines from "./screens/admin/ManageMedicines.jsx";
import ManageAppointments from "./screens/admin/ManageAppointments.jsx";
import ManageDepartments from "./screens/admin/ManageDepartments.jsx";

// Seller/pharmacist
import SellMedicineScreen from "../src/screens/pharmacist/pharmacistScreen.jsx";

//Recetionist
import WalkInAppointmentScreen from "./screens/receptionist/WalkInAppointmentScreen.jsx";
import ManageAppointmentsReceptionist from "./screens/receptionist/ManageAppointmentsReceptionist.jsx";

function App() {
  const { userInfo } = useSelector((state) => state.auth);

  return (
    <Router>
      <Header />
      <main className="flex-grow-1" style={{ margin: 0, padding: 0 }}>
        <Routes>
          {/* Public Home Page */}
          <Route path="/" element={<HomeScreen />} />

          {/* Auth */}
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
          <Route
            path="/reset-password/:token"
            element={<ResetPasswordScreen />}
          />

          {/* Patient Routes */}
          <Route
            path="/patient/appointments"
            element={
              <PrivateRoute roles={["patient"]}>
                <AppointmentScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/patient/myappointments"
            element={
              <PrivateRoute roles={["patient"]}>
                <MyAppointmentsScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/patient/labreports"
            element={
              <PrivateRoute roles={["patient"]}>
                <LabReportsScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/patient/medicine"
            element={
              <PrivateRoute roles={["patient"]}>
                <MedicineScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/patient/history"
            element={
              <PrivateRoute roles={["patient"]}>
                <HistoryScreen />
              </PrivateRoute>
            }
          />

          {/* Doctor Routes */}
          <Route
            path="/doctor/dashboard"
            element={
              <PrivateRoute roles={["doctor"]}>
                <DoctorDashboard />
              </PrivateRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute roles={["admin"]}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/doctors"
            element={
              <PrivateRoute roles={["admin"]}>
                <ManageDoctors />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/medicines"
            element={
              <PrivateRoute roles={["admin"]}>
                <ManageMedicines />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/appointments"
            element={
              <PrivateRoute roles={["admin"]}>
                <ManageAppointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/departments"
            element={
              <PrivateRoute roles={["admin"]}>
                <ManageDepartments />
              </PrivateRoute>
            }
          />
          {/* Pharmacist */}
          <Route
            path="/counter"
            element={
              <PrivateRoute roles={["pharmacist"]}>
                <SellMedicineScreen />
              </PrivateRoute>
            }
          />
          {/* Receptionist */}
          <Route
            path="/receptionist/walk-in"
            element={
              <PrivateRoute roles={["receptionist"]}>
                <WalkInAppointmentScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/receptionist/appointments"
            element={
              <PrivateRoute roles={["receptionist"]}>
                <ManageAppointmentsReceptionist />
              </PrivateRoute>
            }
          />
          {/* Fallback for unknown routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
      <ToastMessage />
    </Router>
  );
}

export default App;
